export default __webpack_public_path__ + "static/media/icon_chevron-right.8fd5aca0.svg";